export const iconFontAwesomeHumanitarianSchoolCircleExclamation = (
	<i className="fa-solid fa-school-circle-exclamation"></i>
);
